import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const Authmiddleware = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation(); // Use the hook to get the current location
  const isUser = localStorage.getItem("authUser");
  const isAgency = localStorage.getItem("agencyInfo");

  if (!isAgency || !isUser) {
    localStorage.removeItem("authUser");
    localStorage.removeItem("agencyInfo");

    // Pass location state to the login page
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default Authmiddleware;
